const BROWSERS = {
    CHROME: 'Chrome',
    EDGE: 'Edge',
    SAFARI: 'Safari',
    BRAVE: 'Brave',
    ARC: 'Arc',
    OPERA: 'Opera',
    FIREFOX: 'Firefox',
    IE: 'Internet Explorer',
}

export default BROWSERS
